import businessStrategyLottie from "../images/lottie/businessStrategy_lottie.json";
import designLottie from "../images/lottie/design_lottie.json";
import webDevelopmentLottie from "../images/lottie/web_development_lottie.json";
import programmingLottie from "../images/lottie/programming_lottie.json";
import projectManagementLottie from "../images/lottie/projectManagement_lottie.json";
import projectTeamLottie from "../images/lottie/projectTeamLottie.json";
import handshakeLottie from "../images/lottie/handshake_lottie.json";
import teamproject from "../images/lottie/teamproject.json";
import applyPageTeamLottie from "../images/lottie/applyPageTeamLottie.json";
import merchPageAnimation from "../images/lottie/merchPageAnimation.json";

export const applyPageTeamLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: applyPageTeamLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};
export const projectTeamLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: projectTeamLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMin slice",
  },
};

export const teamProjectLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: teamproject,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const businessStrategyLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: businessStrategyLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const designLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: designLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const webDevelopmentLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: webDevelopmentLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const programmingLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: programmingLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const projectManagementLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: projectManagementLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const handshakeLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: handshakeLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const merchPageLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: merchPageAnimation,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};
